document.addEventListener("DOMContentLoaded", function () {

    // Sirf homepage par popup show karo
    if (window.location.pathname !== "/") {
        return;
    }

    const popup = document.getElementById("offerPopup");

    if (!popup) return;

    popup.style.display = "flex";

    // Close button
    document.querySelector(".popup-close").addEventListener("click", function () {
        popup.style.display = "none";
    });

    // Overlay par click karne se bhi close
    popup.addEventListener("click", function (e) {
        if (e.target === popup) {
            popup.style.display = "none";
        }
    });

});